// extracted by mini-css-extract-plugin
module.exports = {"item":"NavMenuItem_item__WHBkK","active":"NavMenuItem_active__5jsww","buyBonusIcon":"NavMenuItem_buyBonusIcon__V4O1N","aviator":"NavMenuItem_aviator__FYVnJ"};